import { Select } from "antd";
import moment from "moment";

const TimeSelect = ({ value, onChange, disabled, startTime }) => {
  const generateTimes = (startHour) => {
    const times = [];
    for (let hour = startHour; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time = `${String(hour).padStart(2, "0")}:${String(
          minute
        ).padStart(2, "0")}`;
        times.push(time);
      }
    }
    return times;
  };

  const times = startTime
    ? generateTimes(moment(startTime, "HH:mm").hour())
    : generateTimes(0);

  return (
    <Select
      style={{ width: 120 }}
      value={value}
      onChange={onChange}
      disabled={disabled}
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {times.map((time) => (
        <Select.Option key={time} value={time}>
          {time}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TimeSelect;
